import request from '@/utils/request'
//获取单条咨询，攻略文章
export function GetWenzhangone(data) {
  return request({
    url: '/html/wenzhang/one',
    method: 'get',
    params: data 
  })
}
//获取文章标签
export function wenzhangtitle(data) {
  return request({
    url: '/html/wenzhang/teg',
    method: 'get',
    params: data
  })
}
//获取文章标签
export function numberOfViews(params) {
  return request({
    url: '/wenzhang/wenzhang/info',
    method: 'post',
    params
  })
}


// WEBPACK FOOTER //
// ./src/api/wenzhangone.js